<div *ngIf="showContactPopup" class="contact-overlay" (click)="closeContactPopup()"></div>

<div *ngIf="showContactPopup" class="contact-popup" role="dialog" aria-modal="true" aria-label="Contact Details">

  <!-- Header -->
  <div class="contact-header">
    <button type="button" class="close-btn" (click)="closeContactPopup()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>

    <!-- <div class="contact-avatar">{{ getInitials() }}</div> -->

    <!-- <h3 class="contact-title">{{ contactData?.companyName || 'Contact Details' }}</h3> -->
    <h3 class="contact-title">Contact Details</h3>
    <!-- <p class="contact-subtitle" *ngIf="contactData?.contactPerson">
      <mat-icon>person</mat-icon> {{ contactData.contactPerson }}
    </p> -->
  </div>

  <!-- Contact Info -->
  <div class="contact-details-container">

    <div class="info-row">
      <div class="info-icon"><mat-icon>business</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Company Name</span>
        <span class="info-value">{{ contactData?.companyName || 'N/A' }}</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon"><mat-icon>person</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Contact Person</span>
        <span class="info-value">{{ contactData?.contactPerson || 'N/A' }}</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon"><mat-icon>email</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Email</span>
        <a *ngIf="contactData?.email" class="info-value link" [href]="'mailto:' + contactData.email">{{ contactData.email }}</a>
        <span *ngIf="!contactData?.email" class="info-value muted">N/A</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon"><mat-icon>call</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Phone</span>
        <a *ngIf="contactData?.phone" class="info-value link" [href]="'tel:' + contactData.phone">{{ contactData.phone }}</a>
        <span *ngIf="!contactData?.phone" class="info-value muted">N/A</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon"><mat-icon>print</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Fax</span>
        <a *ngIf="contactData?.fax" class="info-value link" [href]="'tel:' + contactData.fax">{{ contactData.fax }}</a>
        <span *ngIf="!contactData?.fax" class="info-value muted">N/A</span>
      </div>
    </div>

    <div class="info-row">
      <div class="info-icon"><mat-icon>location_on</mat-icon></div>
      <div class="info-body">
        <span class="info-label">Address</span>
        <span class="info-value">{{ contactData?.address || 'N/A' }}</span>
      </div>
    </div>

  </div>

  <!-- Footer -->
  <!-- <div class="contact-footer">
    <a *ngIf="contactData?.email" class="btn-primary" [href]="'mailto:' + contactData.email">
      <mat-icon>email</mat-icon> Send Email
    </a>
    <button type="button" class="btn-secondary" (click)="closeContactPopup()">Close</button>
  </div> -->
</div>
